export default __webpack_public_path__ + "static/media/avater8.1660df93.png";